import React, { useState, useEffect, useRef } from 'react';
import useInView from '../../hooks/useInView';
import statsData from './statsData';
import './Stats.css';

const ANIMATION_DURATION = 2000;

const easeInOut = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

const AnimatedNumber = ({ value, prefix, suffix, shouldAnimate }) => {
  const [displayValue, setDisplayValue] = useState(0);
  const hasAnimated = useRef(false);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!shouldAnimate || hasAnimated.current) return;
    hasAnimated.current = true;

    const startTime = performance.now();

    const tick = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / ANIMATION_DURATION, 1);
      const easedProgress = easeInOut(progress);

      setDisplayValue(Math.round(easedProgress * value));

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      }
    };

    rafRef.current = requestAnimationFrame(tick);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [shouldAnimate, value]);

  return (
    <span className="stats-number">
      {prefix}{displayValue}{suffix}
    </span>
  );
};

const Stats = () => {
  const { ref, inView } = useInView({ threshold: 0.3 });

  return (
    <section
      ref={ref}
      className={`stats-section${inView ? ' stats-section--visible' : ''}`}
    >
      <div className="stats-container">
        <div className="stats-grid">
          {statsData.map((stat, i) => (
            <div key={i} className={`stats-item stats-item--${i}`}>
              <AnimatedNumber
                value={stat.value}
                prefix={stat.prefix}
                suffix={stat.suffix}
                shouldAnimate={inView}
              />
              <p className="stats-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
